














































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import { SearchEventBus, SearchEventBusEvents } from '@/webcomponents/header/components/SearchEventBus';
import { LEGAL_LINK_CLICKED_EVENT } from '@/webcomponents/footer-navigation/FooterNavigationItem.vue';
import { JumpToEventBusEvents, JumpToEventBus } from './JumpToEventBus';
import i18n from './i18n';

const SearchIcon = () => import('@/common/icons/search-new.svg');
const CloseNewIcon = () => import('@/common/icons/close-new.svg');
const ArrowRightIcon = () => import('@/common/icons/arrow-right.svg');

const MetaNavigationProps = Vue.extend({
  props: {
    menuOpen: Boolean,
    searchOpen: Boolean,
    announcementOpen: Boolean,
    privacyActionName: String,
  },
});

@Component({
  components: {
    SearchIcon,
    CloseNewIcon,
    ArrowRightIcon,
  },
  i18n,
})
export default class MetaNavigation extends mixins(MetaNavigationProps) {
  $refs!: {
    searchCloseButton: HTMLButtonElement; // referenced in search for closing on pressing "esc" key
  };

  fadeIn = false;
  loginOpen = false;

  onLegalLinkClick () {
    window.dispatchEvent(new CustomEvent(LEGAL_LINK_CLICKED_EVENT, {
      detail: this.privacyActionName,
    }));
    TrackingPushService.getInstance().pushTrackingAttributes('link', 'Meta Navigation', this.privacyActionName);
  }

  onJumpToNavigationClick () {
    JumpToEventBus.$emit(JumpToEventBusEvents.JumpToNavigation);
  }

  onJumpToFooterClick () {
    JumpToEventBus.$emit(JumpToEventBusEvents.JumpToFooter);
  }

  onSearchClicked () {
    this.$emit('search-clicked');
    TrackingPushService.getInstance().pushTrackingAttributes('link', 'Meta Navigation', 'search flyout');
  }

  onLoginClicked () {
    this.loginOpen = !this.loginOpen;
    const event = new CustomEvent('loginClicked', {
      bubbles: true,
      composed: true,
    });
    this.$el.dispatchEvent(event);
    TrackingPushService.getInstance().pushTrackingAttributes('link', 'Meta Navigation', 'login flyout');
  }

  onMenuClick () {
    this.$emit('mobile-menu-toggle');
  }

  get rootClass () {
    return {
      'brandhub-meta-navigation--in': this.fadeIn,
      'brandhub-meta-navigation--search-open': this.searchOpen,
      'brandhub-meta-navigation--menu-open': this.menuOpen,
      'brandhub-meta-navigation--announcement-open': this.announcementOpen,
    };
  }

  get loginClass () {
    return {
      'brandhub-meta-navigation__item-button--login-open': this.loginOpen,
    };
  }

  focusCloseButton () {
    this.$refs.searchCloseButton.focus();
  }

  handleSearchCloseButtonTab () {
    SearchEventBus.$emit(SearchEventBusEvents.FocusInput);
  }

  mounted () {
    SearchEventBus.$on(SearchEventBusEvents.FocusCloseButton, this.focusCloseButton);
    setTimeout(() => {
      this.fadeIn = true;
    }, 25);
    const root = window.document.querySelector('.root');
    if (root) {
      root.id = 'content';
    }
  }
}
